import { NextContentfulImage } from "@components/Image";
import { ImageWrapperType } from "@customTypes/imageWrapper";
import { COVEO_IGNORE_CLASS } from "@utilities/coveoConst";
import clsx from "clsx";

import styles from "./C263_ResponsiveImage.module.scss";

type ASPECT_RATIO = "Retain Aspect Ratio" | "Square (1:1)" | "9:5";

export interface ResponsiveImageProps {
  image: ImageWrapperType;
  inSublayout: boolean;
  includeWrapper: boolean;
  mobileAspectRatio: ASPECT_RATIO;
  maintainQuality: boolean;
}

const ResponsiveImage = (props: { content: ResponsiveImageProps }) => {
  const { content } = props;

  const image = content?.image;

  if (!image) {
    return null;
  }

  const alt = content.image.fields.altText;
  const { includeWrapper, inSublayout } = content;

  return (
    <div
      className={clsx(
        "component",
        styles["responsive-image"],
        includeWrapper && "wrapper",
        COVEO_IGNORE_CLASS
      )}
    >
      <NextContentfulImage
        alt={alt}
        src={image.fields.url}
        height={image.fields.height}
        width={image.fields.width}
        sizes={inSublayout ? "(max-width: 768px) 100vw, 25vw" : "100vw"}
        loading="eager"
      />
    </div>
  );
};

export default ResponsiveImage;
